import './Checkout.css';
import React, { useEffect } from 'react';
import { ICheckoutState } from '../../store/CheckoutContext';
import Basket from '../../components/checkout/Basket';
import { Grid, Typography } from '@material-ui/core';
import { GenerateFields } from '../../components/checkout/CheckoutInput';

interface Props {
  state: ICheckoutState;
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}

const StepThird: React.FC<Props> = props => {
  const { state, setState } = props;

  return (
    <div className="CheckoutIframe">
      <Grid item>
        <div className="">
          <Basket />
        </div>
      </Grid>
    </div>
  );
};

export default StepThird;
